import { render, staticRenderFns } from "./OrderTile.vue?vue&type=template&id=1d4237c4&"
import script from "./OrderTile.vue?vue&type=script&lang=ts&"
export * from "./OrderTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports